import React from 'react';
import ReactDom from 'react-dom';
import styled from 'styled-components';

const StyledImg = styled.img`
    opacity: 1;
    transition: opacity ${props=>props.duration}ms;

    &.hide {
        opacity: 0;
    }
`;

export default class ImageComponent extends React.Component {

    constructor( props ){

        super( props );

        this.state = {
            image : props.image,
            changing: false
        }

    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.image != this.state.image ){

            this.setState( { changing: true }, (  ) => {
                setTimeout( () =>{
                    this.setState({changing:false, image: nextProps.image });
                }, this.props.duration );
            });

        }
        
    }

    render () {

        return (
            <StyledImg duration={this.props.duration} className={ this.state.changing ? 'hide' : 'show' } src={this.state.image} />
        )

    }

}